module.exports = __webpack_public_path__ + "static/media/instagram-vector.84637a2c.png";